import { getData } from '../plugins/ApiCalls'

export function getIcons(library, variation) {
  if (!variation) {
    return getData(`icons/${library}`)
  }

  return getData(`icons/${library}/${variation}`)
}
